import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  OPTION_IDS_SELECTABLE_FEATURE_KEY,
  optionIdsSelectableAdapter,
  OptionIdsSelectableState,
} from './option-ids-selectable.reducer';

// Lookup the 'SearchFilterOptions' feature state managed by NgRx
export const getOptionIdsSelectableState = createFeatureSelector<OptionIdsSelectableState>(
  OPTION_IDS_SELECTABLE_FEATURE_KEY
);

const { selectAll } = optionIdsSelectableAdapter.getSelectors();

export const getAllOptionIdsSelectable = createSelector(
  getOptionIdsSelectableState,
  (state: OptionIdsSelectableState) => selectAll(state)
);
